import { render, staticRenderFns } from "./EditFeed.vue?vue&type=template&id=b03dfc3a&scoped=true&"
import script from "./EditFeed.vue?vue&type=script&lang=js&"
export * from "./EditFeed.vue?vue&type=script&lang=js&"
import style0 from "./EditFeed.vue?vue&type=style&index=0&id=b03dfc3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03dfc3a",
  null
  
)

export default component.exports